import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import blueCheck from "./images/blue-check.svg";
import greenCheck from "./images/green-check.svg";
import { getBoldText } from "../../../utils/helpers/get-span-for-bold-text";

const PostBcVasPitchingSelectedUpgradedCard = ({ data }) => {
    const {
        title,
        footer,
        selectedPlan: {
            header: selectedPlanHeader,
            itemName: selectedPlanItemName,
            itemDescriptions: selectedPlanItemDescription,
            price: selectedPlanPrice
        },
        upgradePlan: {
            header: upgradedPlanHeader,
            itemName: upgradePlanItemName,
            itemDescriptions: upgradePlanItemDescription,
            price: upgradePlanPrice
        }
    } = data;

    return (
        <div styleName={"styles.wrapper"}>
            <div styleName={"styles.title"}>{title}</div>
            <div styleName={"styles.outer"}>
                <div styleName={"styles.headerWrap"}>
                    <div styleName={"styles.leftTab"}>
                        <p styleName={"styles.selectedPlan"}>{getBoldText(selectedPlanHeader)}</p>
                    </div>
                    <div styleName={"styles.rightTab"}>
                        <p styleName={"styles.upgradedPlan"}>{getBoldText(upgradedPlanHeader)}</p>
                    </div>
                </div>
                <div styleName={"styles.contentWrap"}>
                    <div styleName={"styles.selectedOptions"}>
                        <p styleName={"styles.options"}>
                            <img src={blueCheck} />
                            {selectedPlanItemName}
                        </p>
                        {selectedPlanItemDescription.map((item) => (
                            <p styleName={"styles.options"}>
                                <img src={blueCheck} />
                                {item}
                            </p>
                        ))}
                    </div>
                    <div styleName={"styles.selectedOptions"}>
                        <p styleName={"styles.options"}>
                            <img src={greenCheck} />
                            {upgradePlanItemName}
                        </p>
                        {upgradePlanItemDescription.map((item) => (
                            <p styleName={"styles.options"}>
                                <img src={greenCheck} />
                                {item}
                            </p>
                        ))}
                    </div>
                </div>
                <div styleName={"styles.bottomSection"}>
                    <div styleName={"styles.bottomAmountWrap"}>
                        <p styleName={"styles.perWeekAmount"}>
                            {getBoldText(selectedPlanPrice)}
                        </p>
                        <p styleName={"styles.perWeekAmount"}>
                            {getBoldText(upgradePlanPrice)}
                        </p>
                    </div>
                    <div styleName={"styles.gradientWrapper"}>
                        <div styleName={"styles.bottomGradient"}>
                            <p styleName={"styles.userChoice"}>{footer}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PostBcVasPitchingSelectedUpgradedCard.propTypes = {
    data: PropTypes.object
};
export default PostBcVasPitchingSelectedUpgradedCard;
